import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './savedSearchListStyles';

import { redirectWithParams } from 'buyside/util/filterRedirect';

const SavedSearchListItem = ({
  savedSearch,
  activeSavedSearch,
  openSavedSearch,
  clearSavedSearches
}) => {
  const navigate = useNavigate();

  const currentSavedSearch = savedSearch.savedSearch;
  const searchParams = JSON.parse(currentSavedSearch.criteria);

  const handleChange = () => {
    if (activeSavedSearch === savedSearch.id) {
      clearSavedSearches();
      navigate('/');
    } else {
      openSavedSearch(savedSearch.id);
      redirectWithParams(searchParams, navigate)();
    }
  };

  return (
    <label className={styles.savedSearchListItem}>
      <input
        type="radio"
        name="saved_search"
        value={currentSavedSearch.searchKey}
        onChange={handleChange}
        checked={activeSavedSearch === savedSearch.id}
      />
      <span>{savedSearch.name ? savedSearch.name : 'N/A'}</span>
    </label>
  );
};

export default SavedSearchListItem;
